module.exports = __webpack_public_path__ + "c24531bcabffb4d82b61be4f8506cf00.svg";